import { useEffect } from 'react';
import { logout } from '../auth/authService';
import { useNavigate } from 'react-router-dom';

const Logout = () => {
  const navigate = useNavigate();

  useEffect(() => {
    logout();
    navigate('/login', { replace: true });
  }, [navigate]);

  return null;
};

export default Logout;
